package app.api

import app.client
import app.model.ProjectRelease
import app.plugin.Routing
import dev.fritz2.core.RootStore
import io.ktor.client.call.*
import io.ktor.client.plugins.resources.*
import kotlinx.coroutines.Job

class ProjectReleaseApi : RootStore<ProjectRelease?>(null, job = Job()) {
    val handler = handle { _, id: String ->
        val releaseId = id.toInt()
        client.get(Routing.ProjectReleases.Id(id = releaseId)).body<ProjectRelease>()
    }

}
